import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DocumentSearchPage } from "src/components/views/documents/search/DocumentSearchPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/documents/search")({
	staticData: { title: i18n.t("documents"), legacyViewKey: "documentSearchPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DocumentSearchPage />;
}
